module.exports = __webpack_public_path__ + "medical_type_ico_2.svg?88e992b9cbf2e98813d0a2792ae2784b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/medical_type_ico_2.svg
// module id = 29
// module chunks = 0